<form [formGroup]="bookingTCViewerForm" id="booking-tc-viewer-form" class="template-form">
  <div id="booking-main-container" class="container">
    <div id="booking-error-div" *ngIf="bookingTCViewerForm.invalid">
      <mat-error>Form is invalid</mat-error>
    </div>

    <read-only-form-field title="Service number" data-testid="booking-number-input-field" value="{{_booking.transactionBookingId}}"/>

    <read-only-form-field title="Name" data-testid="booking-terms-and-conditions-input-field" value="{{_bookingTermsAndConditions.template.templateName}}" />

    <read-only-form-field title="Description" data-testid="booking-description-input-field" value="{{_bookingTermsAndConditions.template.templateDescription}}" />

    <read-only-form-field title="Service Template Notes" data-testid="booking-template-notes-input-field" value="{{_bookingTermsAndConditions.bookingTemplateNotes}}" />
  </div>
  <br>
  <div class="row">
    <ng-container #container></ng-container>
  </div>
</form>
